import {GetDataByDataQueryApiResponse} from '@dms/api/core';
import {RentalOrderResponseBody} from '@dms/api/rental';

import {parseDate} from 'shared/web';

import {RentalOrderGridCard} from '../types/RentalOrderGridCard';

export const getCardsForColumn = (
  state: RentalOrderResponseBody['state'],
  rentalOrders: GetDataByDataQueryApiResponse['rows']
): RentalOrderGridCard[] => {
  const cards = rentalOrders.filter((row) => row.cells?.state?.value?.key === state);

  return cards.map((card) => {
    const rentDate = card.cells?.scheduledRent?.value ?? card.cells?.vehicleRent?.value;
    const returnDate = card.cells?.scheduledReturn?.value ?? card.cells?.vehicleReturn?.value;

    return {
      id: card.id,
      number: card.cells?.number?.value,
      vehicleTitle: card.cells?.vehicleTitle?.value?.label,
      vehicleId: card.cells?.vehicleTitle?.value?.id,
      customerName: card.cells?.customer?.value?.label,
      customerId: card.cells?.customer?.value?.id,
      rentDate: rentDate ? parseDate(rentDate) : null,
      returnDate: returnDate ? parseDate(returnDate) : null,
      dailyRate: card.cells?.dailyRate?.value,
      expectedPriceWithVat: card.cells?.expectedPriceWithVat?.value,
      salePriceWithVat: card.cells?.salePriceWithVat?.value,
      licensePlate: card.cells?.licensePlate?.value,
      state,
    };
  });
};
